import React from "react"
import { Query } from "react-apollo"
import gql from "graphql-tag"

const QUERY = gql`
  {
    caseStudies @client {
      id
      featuredOnLandingPage
      featuredOnCaseStudiesPage
      company
      previewBio
      landingPageHeroTitle
      landingPageHeroImage
      project
      projectLogo
      companyLogo
      companyType
      companyLocation
      replaceLogoWithString
      projectGoal
      tools
      websiteString
      websiteUrl
      previewBackground
      imageSectionImage
      imageSectionImageAltText
      heroBackground
      caseStudiesPageImage
      caseStudiesPageImageAltText
      quote
      quoteImage
      quoteAuthor
      quoteAuthorPosition
      tags
      title
      path
      primaryColor
      secondaryColor
    }
  }
`

class CaseStudyProvider extends React.Component {
  render() {
    return (
      <Query query={QUERY}>
        {({ data }) => this.props.render(data.caseStudies)}
      </Query>
    )
  }
}

export default CaseStudyProvider



// WEBPACK FOOTER //
// ./src/components/CaseStudyProvider/index.jsx